export const validatePercentage = (val) => {
  if (+val > 100 || +val <= 0) {
    return +val > 100
      ? "Percentage cannot be more than 100"
      : "Percentage should not be 0";
  }
};

export const checkIfMinor = (date) => {
  var today = new Date().getTime();
  var birthDate = new Date(date).getTime();
  const age = (today - birthDate) / 365 / 24 / 3600 / 1000;
  return age < 18;
};
export const getFieldsFromMap = (
  type,
  Schema,
  noOfApplicants,
  customHandler
) => {
  const fields = {};
  for (let i = 1; i < noOfApplicants + 1; i++) {
    for (let k in Schema) {
      const field = { ...Schema[k] };
      fields[`${type ? type + "_" : ""}${k}_${i}`] = field;

      customHandler && customHandler(field, i, k);
    }
  }
  return fields;
};

export const getFieldList = (fieldMap) => {
  const fieldList = Object.keys(fieldMap).map((k) => {
    const field = fieldMap[k];
    field.key = k;
    return field;
  });

  return fieldList.filter((f) => !f.hidden);
};

export const getConvertedFormValues = (formValues, allFields) => {
  const newFormValues = { ...formValues };
  for (let f in allFields) {
    if (f.hidden) {
      delete newFormValues[f.key];
    }
  }
  const conversionMap = {
    //  # gets replaced with 1,2,3
    //  @ gets replaced with '',2,3
    //  ~ gets replaced with F,S,T
    pan: "i_pangno@",
    name: "i_fname@", // jholder1,jholder2
    email: "i_email@",
    gender: "i_invgender@",
    dob: "i_dob@", //jh1dob,jh2dob
    mobile: "i_mobileno@",
    category: "i_category@",
    status: "", //not needed
    kycCompleted: "i_Ckyc#",
    kyc_occupation: "i_Occpn@", //i_Soccpn, i_Toccpn
    kyc_annualIncome: "i_income@", //SAnnualIncome, TAnnualIncome
    kyc_birthCountry: "~CountryofBirth",
    kyc_nationality: "~Nationality",
    kyc_residentOfIndia: "",
    kyc_residency: "~TaxResident",
    kyc_foreignTaxId: "~ForeignTaxId",
    kyc_foreignTaxIdType: "~ForeignTaxType",
    countrycode: "",
    kyc_address: "i_invadd#",
    kyc_country: "i_invcountry@",
    kyc_state: "i_invstate@",
    kyc_city: "i_invcity@",
    kyc_pincode: "i_invpin@",
    kyc_politicallexposed: "~PEP",
    kyc_politicallyexposedrelative: "~PREP",

    nom_name: "i_Nominee@",
    nom_relationship: "i_NomRelation@",
    nom_guardian: "i_@nomGuardian",
    nom_dob: "i_NomDOB@",
    nom_gender: "nom#gender",
    nom_percentage: "i_Nominee#percentage",
    nom_email: "nom#email",
    nom_address: "i_nomadd#1",
    nom_country: "i_nom@country",
    nom_state: "i_nomstate@",
    nom_city: "i_nomcity@",
    nom_pincode: "i_nompin@",
  };

  const finalValues = {};

  for (let fkey in newFormValues) {
    const key = fkey.replace(/_\d/g, "");
    const [num_part] = fkey.match(/_\d/g) || ["_1"];
    const number = String(num_part).slice(1);

    const templateKey = conversionMap[key];

    if (!templateKey) {
      console.log({ key });
      continue;
    }

    const wildCard = [`@`, "#", "~"].find((t) => templateKey.includes(t));

    let finalNumber = number;

    if (wildCard === "@" && parseInt(number) === 1) {
      finalNumber = "";
    } else if (wildCard === `~`) {
      finalNumber = ["F", "S", "T"][number - 1];
    }
    const specialKeys = {
      name_2: "i_jholder1",
      name_3: "i_jholder2",
      dob_2: "i_jh1dob",
      dob_3: "i_jh2dob",
      kyc_occupation_2: "i_Soccpn",
      kyc_occupation_3: "i_Toccpn",
      kyc_annualIncome_2: "SAnnualIncome",
      kyc_annualIncome_3: "TAnnualIncome",
      nom_address_1: "i_nomadd1",
    };
    if (fkey in specialKeys) {
      finalValues[specialKeys[fkey]] = newFormValues[fkey];
    } else {
      const actualKey = templateKey.replace(wildCard, finalNumber);
      finalValues[actualKey] = newFormValues[fkey];
    }
  }

  return finalValues;
};

export function $wait(time = 500) {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res();
    }, time);
  });
}
